import React, { useContext } from 'react';

import { MotionBox } from 'components/common/MotionBox';
import { IntersectionContext } from 'components/intersection-observer';
import { cardContainerInvert, cardItemVariants } from 'theme/motion.variants';

import {
  TestimonialsContainer,
  TestimonialsHeading,
  TestimonialsWrapper,
  TestimonialsCard,
  TestimonialsAvatar,
  TestimonialsParagraph,
  TestimonialsUser,
  TestimonialsStar
} from './testimonials.styles';
import { Underline } from 'components/common/Underline';

import { testimonialsData } from './testimonials.data';

const Testimonials = () => {
  const { inView } = useContext(IntersectionContext);

  return (
    <TestimonialsContainer id="testimonials">
      <TestimonialsHeading>Testimonials</TestimonialsHeading>
      <Underline />
      <TestimonialsWrapper
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        exit="exit"
        variants={cardContainerInvert}
      >
        {testimonialsData.map(({ id, src, title, paragraph, star }) => (
          <MotionBox variants={cardItemVariants} key={id}>
            <TestimonialsCard whileHover={{ scale: 1.05, transition: 0.2 }}>
              <TestimonialsAvatar src={src} />
              <TestimonialsParagraph>{paragraph}</TestimonialsParagraph>
              <TestimonialsUser>{title}</TestimonialsUser>
              <TestimonialsStar role="img">
                {`⭐`.repeat(star)}
                <span style={{ filter: `grayscale(100%)` }}>
                  {`⭐`.repeat(5 - star)}
                </span>
              </TestimonialsStar>
            </TestimonialsCard>
          </MotionBox>
        ))}
      </TestimonialsWrapper>
    </TestimonialsContainer>
  );
};

export default Testimonials;
